import React from 'react'
import {Col, Form, Input} from "antd";
import {Field} from "./index";
import Utils from "../../utils";
import {LabelWithTooltip} from "./components/LabelWithTooltip";

export class FieldCalculated extends Field {

  constructor(obj={}) {
    super(obj);
    this.needRefresh = true;
    this.labelPosition = obj.labelPosition ?? 'top'; // Agregar propiedad labelPosition
  }

  getComponent (form, changed) {
    const name = this.name;
    const formula = this.formula;
    const condition = this.condition;
    const label = this.label;
    const help = this.help;
    const disabled = this.disabled;
    const size = this.size;
    const labelPosition = this.labelPosition;

    // Configuración de la posición de la etiqueta
    const labelProps = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    };

    // Si labelPosition es 'left', configurar para mostrar la etiqueta a la izquierda
    if (labelPosition === 'left') {
      labelProps.labelCol = { span: 8 };
      labelProps.wrapperCol = { span: 16 };
    }

    return () => {
      // Recalcular el valor cada vez que se renderiza el componente
      const calculatedValue = Utils.evaluateFormula(formula, form);
      const currentValue = form.getFieldValue(name);

      // Solo actualizar si el valor calculado es diferente
      if (calculatedValue !== currentValue) {
        form.setFieldsValue({[name]: calculatedValue});
      }

      return (
        <Col className={!Utils.evaluateFormula(condition, form) ? "display-none" : "visible"} xs={24} sm={24} md={size}>
          <Form.Item
            label={<LabelWithTooltip label={label} help={help}/>}
            name={name}
            {...labelProps}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
      );
    };
  }

  transformToField = (data) => {
    console.log('formula', data)
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.value = data.value ?? "";
    this.disabled = data.disabled ?? false;
    this.condition = data.condition ?? true;
    this.help = data.help;
    this.formula = data.formula ?? 0;
    this.labelPosition = data.labelPosition ?? 'top'; // Agregar propiedad labelPosition
    return this;
  }
}